import React, { Component } from "react";
import { Icon, message, Tooltip, Button, Input, Row, Col } from 'antd';
import LangContext from "../contextProvider/LangContext";
import { Job, OutputType, ProcessType, User } from "../JmReact.js";
import GenericModal from "./GenericModal";

class SMSSend extends Component<Props, State> {

    static contextType = LangContext;

    state = {
        _message: "",
        _mobile: "",
    }

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultMobile !== this.props.defaultMobile) {
            this.setState({
                _mobile: this.props.defaultMobile,
            })
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {

        const { _message, _mobile } = this.state;
        let chartersCount = _message ? new Blob([_message]).size : 0;
        let smsPack = Math.ceil(chartersCount / 134);
        let smsPackView = smsPack > 4 ? 4 : smsPack;

        return (<GenericModal {...this.props}
            width={500}
            footer={[
                <Button style={{ marginLeft: 10 }} onClick={this.props.onCancel}>{this.getText(22621)}</Button>,
                <Button type="primary" disabled={!_message || !_mobile || smsPack > 4} onClick={() => {
                    if (!RegExp(/^05\d([-]{0,1})\d{7}$/).test(_mobile)) {
                        message.error(this.getText(22624));
                        return;
                    }
                    this.sendAPI("ac_insert_message", {
                        _custId: "0",
                        _custName: "",
                        _custDestination: _mobile,
                        _messageId: "0",
                        _prm1: "",
                        _prm2: "",
                        _prm3: "",
                        _prm4: "",
                        _prm5: "",
                        _messageText: _message,
                        _messageType: "2",
                    }, () => {
                        message.success(this.getText(22625));
                        if (this.props.onSuccess) {
                            this.props.onSuccess(_message);
                        } else {
                            this.props.onCancel();
                        }
                    })
                }}>{this.getText(22622)}</Button>
            ]}
        >
            <Row>
                <Col span={6}>
                    {[
                        <p>{this.getText(12356)}</p>,
                        <p><Icon type="mail" />&nbsp;{smsPackView}</p>,
                        <p dir="ltr">{chartersCount} / {smsPackView * 134}</p>,
                        smsPack > 4 ? (<p style={{ color: "red" }}>{this.getText(17718)}</p>) : "",
                        _message && chartersCount > _message.length ? (<p>{this.getText(17719)}</p>) : ""
                    ]}
                </Col>
                <Col span={18}>
                    <Input.TextArea
                        rows={5}
                        value={_message}
                        onChange={(value) => {
                            this.setState({ _message: value.target.value })
                        }} />

                </Col>
                <Col span={6} style={{ marginTop: 5 }}>
                    {this.getText(22623)}
                </Col>
                <Col span={18} style={{ marginTop: 5 }}>
                    <Input
                        value={_mobile}
                        onChange={(value) => {
                            this.setState({ _mobile: value.target.value })
                        }} />

                </Col>
            </Row>


        </GenericModal>)
    }

}

export default SMSSend;